import {
    Component, EventEmitter, Input, OnInit, Output, ViewChild, ElementRef
} from '@angular/core';
import {Layer} from 'storyboard-renderer';
import {TimelineService} from '../timeline.service';
import {Clip} from 'storyboard-renderer';
import {TextClip} from 'storyboard-renderer';
import {ImageClip} from 'storyboard-renderer';
import {AudiogramClip} from 'storyboard-renderer';
import {SpeechIndicatorClip, ClipDimensions, Font} from 'storyboard-renderer';
import {NgbPopover} from '@ng-bootstrap/ng-bootstrap';
import {MediaLibraryComponent} from '../../../../media-library/media-library.component';
import {Media} from 'storyboard-renderer';
import {TextEditorComponent} from '../../text-editor/text-editor.component';
import {AudiogramEditorComponent} from '../../audiogram-editor/audiogram-editor.component';
import {ActivatedRoute} from "@angular/router";
import { EditModal } from '../../shared/edit-modal.service';
import {TranscribeComponent} from "../../transcribe/transcribe.component";
import {Transcription} from "../../shared/Transcription";
import {TextHelper} from "../../shared/TextHelper";
import {Alert} from "../../../../shared/alert/Alert";
import {AlertService} from "../../../../shared/alert/alert.service";
import {AuthService} from "../../../../auth/auth.service";
import {TranscribeService} from "../../shared/transcribe.service";

@Component({
  selector: '.app-video-layer',
  templateUrl: './video-layer.component.html',
  styleUrls: ['./video-layer.component.scss']
})
export class VideoLayerComponent implements OnInit {

  @Input() layer;
  @Input() storyboard;

  @Output() deleteLayerEvent = new EventEmitter();
  @Output() onOpenSRTEditor = new EventEmitter();

  @ViewChild('clips') clipsElement;
  @ViewChild('p') public popover: NgbPopover;
  @ViewChild('layerTitleInput', {read: ElementRef}) layerTitleInput: ElementRef;

  addNewClipMode = false;
  userId = null;
  blockLayer = false;
  showLayerTitleInput = false;

  audioTranscibeDurationLimit = 300000;

  constructor(public timelineService: TimelineService, private modalService: EditModal,
      protected route: ActivatedRoute, private alertService: AlertService, public authService: AuthService) {
    this.route.params.subscribe(params => {
      this.userId = +params['user_id']; // (+) converts string 'id' to a number
    });

    modalService.modalOpened.subscribe((res: any) => {
      this.popoverNo();
    })
  }

  ngOnInit() {
    this.layer.setElementRef(this.clipsElement);
  }

  deleteClip(deleteClip: Clip) {
    this.layer.clips = this.layer.clips.filter((clip: Clip) => clip !== deleteClip);

    // Trigger Storyboard Object Change
    this.timelineService.storyboardChangeEvent.next(this.storyboard);
  }

  swapNewClipMode() {
    this.addNewClipMode = !this.addNewClipMode;
  }

  openTextEditor() {
    const modalRef = this.modalService.open(TextEditorComponent, {
      size: 'lg',
      backdrop: 'static'
    });
    const clip = new TextClip(null);
    modalRef.componentInstance.clip = clip;

    modalRef.result.then((result) => {
      this.addTextClip(result.clip);
    }, (reason) => {});
  }

  addTextClip(clip: TextClip) {
    clip.title = clip.text;
    clip.setDuration(10000);

    if (this.timelineService.getPlayerControl()) {
      clip.setStartsAt(this.timelineService.getPlayerControl().getCurrentTime().as_milliseconds);
    } else {
      clip.setStartsAt(0);
    }

    this.addClip(clip);
    this.swapNewClipMode();
  }

  addSpeechIndicatorClip() {
    let clip = new SpeechIndicatorClip();
    clip.setDuration(10000);

    if (this.timelineService.getPlayerControl()) {
      clip.setStartsAt(this.timelineService.getPlayerControl().getCurrentTime().as_milliseconds);
    } else {
      clip.setStartsAt(0);
    }

    this.addClip(clip);
    this.swapNewClipMode();
  }

  addAudiogramClip(clip: AudiogramClip = null){
    if (!clip){
      clip = new AudiogramClip();
    }
    clip.setDuration(10000);
    if (this.timelineService.getPlayerControl()) {
      clip.setStartsAt(this.timelineService.getPlayerControl().getCurrentTime().as_milliseconds);
    } else {
      clip.setStartsAt(0);
    }
    this.addClip(clip);
    this.swapNewClipMode();
  }

  openAudiogramEditor(){
    const modalRef = this.modalService.open(AudiogramEditorComponent, { size: 'lg' });
    const clip = new AudiogramClip();
    modalRef.componentInstance.clip = clip;

    modalRef.result.then((result) => {
      this.addAudiogramClip(result);
    }, (reason) => {});
  }

  openMediaLibrary() {
    const modalRef = this.modalService.open(MediaLibraryComponent, { size: 'lg' });
    modalRef.componentInstance.name = 'Media Library';
    modalRef.componentInstance.userId = this.userId;

    modalRef.result.then((result) => {
      this.addImageClip(result);
    }, (reason) => {});
  }

  openTranscribeEditor() {
    if(!this.storyboard.attached_audio) {
      this.alertService.danger(new Alert('Please upload the audio file first!'));
      return;
    }

    if(this.storyboard.duration.as_milliseconds > this.audioTranscibeDurationLimit) {
      this.alertService.danger(new Alert('Sorry currently videos up to 5 minutes support subtitle generation.'));
      return;
    }

    const modalRef = this.modalService.open(TranscribeComponent, { size: 'lg', backdrop: 'static', keyboard: false });
    modalRef.componentInstance.name = 'Transcribe Generation';
    modalRef.componentInstance.storyboard = this.storyboard;

    modalRef.result.then((result: Transcription) => {
      this.generateTranscribeClips(result);
    }, (reason) => {

      if(reason) {
        this.alertService.danger(new Alert('Transcribe process was unsuccessful, please try it again or try with an other audio file!'));
      }
    });
  }

  duplicateClip(clip: Clip) {
    let clipCopy;
    switch (clip.constructor.name) {

      case TextClip.name:
        clipCopy = TextClip.fromJson(JSON.parse(JSON.stringify(clip)));
        break;

      case ImageClip.name:
        clipCopy = ImageClip.fromJson(JSON.parse(JSON.stringify(clip)));
        break;

      case SpeechIndicatorClip.name:
        clipCopy = SpeechIndicatorClip.fromJson(JSON.parse(JSON.stringify(clip)));
        break;

      case AudiogramClip.name:
        clipCopy = AudiogramClip.fromJson(JSON.parse(JSON.stringify(clip)));
        break;
    }

    clipCopy.setStartsAt(this.timelineService.getPlayerControl().getCurrentTime().as_milliseconds);
    this.addClip(clipCopy);
  }

  addImageClip(media: Media) {
    const clip = new ImageClip(null);
    clip.title = media.title;
    clip.attachment = media;
    clip.setDuration(10000);

    if (this.timelineService.getPlayerControl()) {
      clip.setStartsAt(this.timelineService.getPlayerControl().getCurrentTime().as_milliseconds);
    } else {
      clip.setStartsAt(0);
    }

    this.addClip(clip);
    this.swapNewClipMode();
  }

  addClip(clip: Clip) {
    this.layer.addClip(clip);

    // Trigger Storyboard Object Change
    this.timelineService.storyboardChangeEvent.next(this.storyboard);
  }

  getClips(): Clip[] {
    return this.layer.clips;
  }

  collapse(layer: Layer) {
    layer.collapsed = !layer.collapsed;
  }

  collisionDetection(clip: Clip) {
    return null;
  }

  snapTo(clip: Clip, targetClip: Clip) {

  }

  popoverYes() {
    this.deleteLayerEvent.next(this.layer);
    if(this.popover)
      this.popover.close();
  }

  popoverNo() {
    if(this.popover)
      this.popover.close();
  }

  toggleBlockLayer(val) {
    val = !val;
    this.blockLayer = val;
    this.layer.toggleBlockLayer(val);
    this.layer.clips.forEach((clip) => {
      clip.blockClip(val)
    })
  }

  toggleLayerTitle() {
    this.showLayerTitleInput = !this.showLayerTitleInput;
    setTimeout(() => {
      this.layerTitleInput.nativeElement.focus();
    }, 0);

    if (!this.layer.title) {
      this.layer.title = 'No title'
    }
  }

  handleInput($event) {
    if ($event.keyCode === 13) {
      this.layerTitleInput.nativeElement.blur();
    }

    if (!this.layer.title) {
      this.layer.title = 'No title'
    }
  }

  openSRTEditor() {
    this.onOpenSRTEditor.emit('');
  }

  hasSRTOnLayer() {
    return this.layer.clips.find(clip => clip.transcription);
  }

  private generateTranscribeClips(transcription: Transcription) {

    // Remove all clips from this layer to avoid overlaps
    this.layer.clips = [];

    for(let i = 0; i < transcription.timedTexts.length; i++) {

      const clip = new TextClip(null);
      clip.setStartsAt(transcription.timedTexts[i].start * 1000);
      clip.setDuration((transcription.timedTexts[i].end - transcription.timedTexts[i].start) * 1000);

      // Set default clip design
      clip.background_color = "#000000";
      clip.background_color_opacity = 0.5;
      const font = new Font();
      font.font_size = "36px";
      font.font_weight = 700;
      font.color = "#ffffff";
      clip.font = font;

      const dimension = new ClipDimensions();

      const wrapLimit = TranscribeService.wrapLimitsByAspectRatio[this.storyboard.aspect_ratio];

      // Wrap text at the nearest space based on the storyboard aspect ratio
      clip.text = TextHelper.wordWrap(transcription.timedTexts[i].text, wrapLimit);
      clip.title = transcription.timedTexts[i].text;

      // Flag as Transcription clip
      clip.transcription = true;
      clip.cssClass = "text-clip transcription-clip";
      clip.timing = transcription.timedTexts[i].timing;

      this.addClip(clip);
    }

    this.swapNewClipMode();

    this.openSRTEditor();

  }

  updatePreview($event: any) {
    setTimeout(() => {
      console.log('xolo');
    }, 100);
    // Trigger Storyboard Object Change
    this.timelineService.storyboardChangeEvent.next(this.storyboard);
  }
}



// WEBPACK FOOTER //
// ./src/app/storyboard/storyboard-edit/timeline/video-layer/video-layer.component.ts